import {
  IMPORT_OPEN_ONBOARDING_SEND_MODAL,
  IMPORT_LOAD_IMPORTED_USERS,
  IMPORT_LOAD_IMPORTED_USERS_SUCCESS,
  IMPORT_LOAD_IMPORTED_USERS_FAIL,
} from 'actions/importJobNotifications';

export const defaultState = {
  // Create / POST state:
  sendMessageType: null,

  // Targets state:
  hasImportedUsers: false,
};

export default function importedUsers(state = defaultState, action) {
  switch (action.type) {
    case IMPORT_OPEN_ONBOARDING_SEND_MODAL: {
      const { messageType } = action.payload;
      return {
        ...state,
        messageType,
      };
    }
    case IMPORT_LOAD_IMPORTED_USERS:
    case IMPORT_LOAD_IMPORTED_USERS_FAIL: {
      return {
        ...state,
        hasImportedUsers: false,
      };
    }
    case IMPORT_LOAD_IMPORTED_USERS_SUCCESS: {
      const { data } = action.payload;
      return {
        ...state,
        hasImportedUsers: !!(data && data.length),
      };
    }
    default:
      return state;
  }
}
